import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E取込データ種別, E償却方法, E償却項目 } from '@/openapi/enum';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';
import C固定資産カラムSelect from '@/components/勘定科目/固定資産カラムSelect/固定資産カラムSelect.vue';
import C固定資産科目Select from '@/components/勘定科目/固定資産科目Select/固定資産科目Select.vue';

import { KeystrokeInputableTextId } from '@/components/keystrokeInputableText/KeystrokeInputableText';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import KeystrokeInputableTextMixin from '@/entries/user/mixins/KeystrokeInputableTextMixin';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';

export type Pdf固定資産台帳Tab = {
  取込データ種別: E取込データ種別;
  pages: Pdf固定資産台帳Page[];
};

export type Pdf固定資産台帳Page = {
  rows: Pdf固定資産台帳Row[];
  selected償却項目s: (string | undefined)[];
};

export type Pdf固定資産台帳Row = {
  勘定科目Pk?: number;
  values: string[];
};

export default mixins(InputableTextMixin, KeystrokeInputableTextMixin, 取込Mixin).extend({
  name: 'Pdf固定資産台帳Tab',

  components: {
    KeystrokeInputableText,
    C固定資産カラムSelect,
    C固定資産科目Select,
  },

  props: {
    pdf固定資産台帳Tab: {
      type: Object as PropType<Pdf固定資産台帳Tab>,
    },
  },
  data(): {
    pageNo: number;
    totalPageCount: number;
    e償却方法: typeof E償却方法;
  } {
    return {
      pageNo: 1,
      totalPageCount: this.pdf固定資産台帳Tab.pages.length,
      e償却方法: E償却方法,
    };
  },

  computed: {
    isFirstPage(): boolean {
      return this.pageNo <= 1;
    },
    isLastPage(): boolean {
      return this.pageNo >= this.totalPageCount;
    },
    currentPage(): Pdf固定資産台帳Page {
      return this.pdf固定資産台帳Tab.pages[this.pageNo - 1];
    },
    selected償却項目s(): (string | undefined)[] {
      return this.currentPage?.selected償却項目s ?? [];
    },
    list(): Pdf固定資産台帳Row[] {
      return this.currentPage?.rows ?? [];
    },
    map(): KeystrokeInputableTextId[][] {
      const map: KeystrokeInputableTextId[][] = [];
      this.list.forEach((l, i) => {
        const row: KeystrokeInputableTextId[] = [];
        l.values.forEach((_, j) => row.push({ id: i * l.values.length + j }));
        map.push(row);
      });
      return map;
    },
  },

  mounted(): void {
    this.setFirstKeystrokeId(this.map);
  },

  methods: {
    async paginate(pageNo: number): Promise<void> {
      if (pageNo < 1 || pageNo > this.totalPageCount) return;
      this.pageNo = pageNo;
      this.setFirstKeystrokeId(this.map);
    },
    deleteColumn(index: number): void {
      this.selected償却項目s.splice(index, 1);
      this.list.forEach((row) => row.values.splice(index, 1));
    },
    deleteRow(index: number): void {
      this.list.splice(index, 1);
    },
    changeCell(value: string | number, row: Pdf固定資産台帳Row, valuesIndex: number): void {
      this.$set(row.values, valuesIndex, String(value));
    },
    is償却方法(column: number): boolean {
      return this.selected償却項目s[column] === E償却項目.償却方法;
    },
  },
});
